import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminSwitchCompanyMutation,
  AdminSwitchCompanyMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { APP_TOKEN_QUERY_KEY } from "../useAppToken";
import { useGraphQlMutation } from "../useGraphQlClient";
import { CURRENT_USER_QUERY_KEY } from "../users/useCurrentUser";

const adminSwitchCompanyMutation = graphql(`
  mutation adminSwitchCompany($input: AdminSwitchCompanyInput!) {
    adminSwitchCompany(input: $input) {
      userGuid
    }
  }
`);

/** Staff only: moves a user, the caller included, into a team of another company. */
export function useSwitchCompany(
  options?: UseMutationOptions<
    AdminSwitchCompanyMutation,
    ClientError,
    AdminSwitchCompanyMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(adminSwitchCompanyMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      // The app token carries the caller's company and team.
      void queryClient.invalidateQueries(APP_TOKEN_QUERY_KEY);
      void queryClient.invalidateQueries(CURRENT_USER_QUERY_KEY);
      void queryClient.invalidateQueries(["userDetails", variables.input.userGuid]);
      options?.onSuccess?.(data, variables, context);
    },
  });
}
